import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import Select from "react-select";
import { components } from "react-select";
import { connectStore } from "redux-box";
import { module as inviteCode } from "@st/inviteCode";
import { module as product } from "@st/product";
import { module as onboard } from "@st/onboard";
import {
  DropDownContainer,
  DropDownTitle,
  DatePickerContainer,
} from "./SchoolGuidedPathEnable.styled";
import { Th, Td, Tr, Table, Grade } from "./SchoolIroEnable.styled";
import {
  UploadContainer,
  SubHeading,
  TagChipsContainer,
  TagChips,
  ThemeButton,
  FlexBetween,
} from "static/styled/custom.styled";

const SchoolLanguages = (props) => {
  const [selectedGrade, setSelectedGrade] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [gradeOption, setGradeOption] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);

  useEffect(() => {
    if (props.inviteCode.schoolGrade.length > 0) {
      let tempGradeOption = [];

      props.inviteCode.schoolGrade.forEach((element) => {
        tempGradeOption.push({ value: element.grade, label: element.name });
      });
      setGradeOption(tempGradeOption);
    }
  }, [props.inviteCode.schoolGrade]);

  useEffect(() => {
    props.inviteCode.getLanguages();
    console.log(props.school_id)
    props.inviteCode.getLanguagesBySchoolId(
    props.inviteCode.schoolEditInfo &&
    props.inviteCode.schoolEditInfo.id
    );
  }, []);

  useEffect(() => {
    if (props.inviteCode.languages.length > 0) {
      let tempLanguageOptions = [];

      props.inviteCode.languages.forEach((element) => {
        tempLanguageOptions.push({ value: element.id, label: element.name });
      });
      setLanguageOptions(tempLanguageOptions);
    }
  }, [props.inviteCode.languages]);

  // Define your tree-like structure
  const gradeOptions = [
    {
      grade: "Grade 1",
      languages: ["English", "Hindi"],
    },
    {
      grade: "Grade 2",
      languages: ["English", "Hindi"],
    },
    {
      grade: "Grade 3",
      languages: ["English", "Hindi"],
    },
  ];

  //   const languages = [
  //     {
  //         label:"English",
  //         value:'english'
  //     },
  //     {
  //         label:"Hindi",
  //         value:"hindi"
  //     }
  //   ]

  // Flatten the options for the dropdown to work with react-dropdown
  const dropdownOptions = gradeOptions.flatMap((grade) => {
    return grade.languages.map((lang) => ({
      label: `${grade.grade} - ${lang}`,
      value: `${grade.grade}-${lang}`,
    }));
  });

  const handleGradeChange = (event) => {
    setSelectedGrade(event);
    // let gradeArr = event.map((ele) => ele.value);
    // updateSchoolGuidedPathState({ selectedGrade: gradeArr });
    // props.schoolGuidedPathUpdated();
  };

  const handleLanguageChange = (event) => {
    setSelectedLanguages(event);
    // let gradeArr = event.map((ele) => ele.value);
    // updateSchoolGuidedPathState({ selectedGrade: gradeArr });
    // props.schoolGuidedPathUpdated();
  };

  const handleAddBtn = () => {
    let temp_list = [...selectedList];

    const index = temp_list.findIndex(
      (item) => item.grade.value === selectedGrade.value
    );

    if (index !== -1) {
      temp_list[index].languages = selectedLanguages;
    } else {
      temp_list.push({
        grade: selectedGrade,
        languages: selectedLanguages,
      });
    }

    setSelectedList(temp_list);
    props.inviteCode.setSchoolLanguagesFormData(
        temp_list);
    setSelectedGrade("");
    setSelectedLanguages([]);
  };

  return (
    props.inviteCode.schoolEditInfo && (
      <React.Fragment>
        {props.inviteCode.schoolEdit ? (
          <div>
            {/* <Select
        isMulti
        options={dropdownOptions}
        onChange={handleChange}
        value={selectedValues}
        placeholder="Select grades and languages"
        getOptionLabel={(e) => e.label}
      />
      <div>
        <h3>Selected Values:</h3>
        {selectedValues.map((selected) => (
          <p key={selected.value}>{selected.label}</p>
        ))}
      </div> */}
            <p>Languages</p>
            <DropDownContainer>
              <DropDownTitle>SCHOOL GRADE</DropDownTitle>
              <Select
                styles={{
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select school grade"}
                value={selectedGrade}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleGradeChange}
                options={gradeOption}
                //   isMulti={true}
              />
            </DropDownContainer>

            <DropDownContainer>
              <DropDownTitle>SELECT Languages</DropDownTitle>
              <Select
                styles={{
                  placeholder: (provided, state) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select grade languages"}
                value={selectedLanguages}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleLanguageChange}
                options={languageOptions}
                isMulti={true}
              />
            </DropDownContainer>

            <ThemeButton
              primary
              type="button"
              disabled={
                props.inviteCode.schoolEdit
                  ? !props.inviteCode.schoolEdit
                  : true
              }
              onClick={handleAddBtn}
              style={{margin:'1rem 0'}}
            >
              Add Grade
            </ThemeButton>

            {selectedList.length > 0 && (
              <Table>
                <thead>
                  <Tr className="text-center">
                    <Th>Grade</Th>
                    <Th>Languages</Th>
                  </Tr>
                </thead>
                <tbody>
                  {selectedList.map((sl) => (
                    <Tr key={sl.grade.value}>
                      <Td className="text-center">{sl.grade.label}</Td>
                      <Td className="text-center">
                        {sl.languages.map((lang) => lang.label).join(", ")}
                      </Td>
                    </Tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
        ) : (
          <React.Fragment>
            <p>Languages</p>

          <Table>
            <thead>
              <Tr className="text-center">
                <Th>Grade</Th>
                <Th>Languages</Th>
              </Tr>
            </thead>
            <tbody>
              {props.inviteCode.schoolLanguages &&
                props.inviteCode.schoolLanguages.map((language) => (
                  <Tr key={language.grade}>
                    <Td className="text-center">{language.grade}</Td>
                    <Td className="text-center">
                      {language.languages &&
                        language.languages.map((lng) => lng.name).join(", ")}
                    </Td>
                  </Tr>
                ))}
            </tbody>
          </Table>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  );
};

export default withRouter(
  connectStore({
    inviteCode,
    onboard,
    product,
  })(SchoolLanguages)
);
